// extracted by mini-css-extract-plugin
export default {"container":"Arrow_container__Eas09","position1":"Arrow_position1__fueeY","position2":"Arrow_position2__MnmwP","arrow":"Arrow_arrow__uw6X-","arrowLabel":"Arrow_arrowLabel__Lb9L+"};